import { call, put, takeLeading } from 'redux-saga/effects'
import * as fromActions from '../../actions/chat.action'
import I18n from 'i18n'
import { getCourseUnreadMessagesCount } from 'api/chat/Get'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'

async function handleGetUnreadMessagesCount(courseId: number) {
  return await getCourseUnreadMessagesCount(courseId)
}

function* getCourseUnreadMessagesCountEffectSaga(action: any) {
  try {
    const data = yield call(handleGetUnreadMessagesCount, action.payload)
    yield put(fromActions.Actions.getCourseUnreadMessagesCountSuccess(data))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.log('error: ', error)
  }
}

export function* getCourseUnreadMessagesCountWatcherSaga() {
  yield takeLeading(fromActions.GET_COURSE_UNREAD_MESSAGES_COUNT, getCourseUnreadMessagesCountEffectSaga)
}
